import React, { useMemo } from 'react'
import { Grid, Tooltip, Typography } from '@material-ui/core'
import { Button } from '@refera/ui-web'

import { useStyles, MINIMIZE_BUTTON_STYLE } from './styles'

export function ColumnHeader({ column, minimizedColumns, toggleColumnMinimized }) {
  const styles = useStyles()
  const childrenCount = column.totalChildrenCount
  const isMinimized = minimizedColumns.has(column.id)
  const showPlus = useMemo(() => !!column?.nextOffset, [column])

  if (isMinimized) {
    return (
      <Grid className={styles.minimizedColumnContainer}>
        <Tooltip title="Visualizar coluna" placement="top">
          <Button
            variant="ghost"
            size="small"
            onClick={() => toggleColumnMinimized(column.id)}
            style={MINIMIZE_BUTTON_STYLE}
          >
            ▶
          </Button>
        </Tooltip>
        <Typography className={styles.minimizedColumnTitle}>
          {column.title}
          <span className={styles.minimizedColumnCount}>
            {childrenCount}
            {showPlus ? '+' : ''}
          </span>
        </Typography>
      </Grid>
    )
  }

  return (
    <Grid className={styles.normalColumnContainer}>
      <Grid className={styles.normalColumnHeader}>
        <Typography className={styles.normalColumnTitle}>{column.title}</Typography>
        <Tooltip title="Minimizar coluna" placement="top">
          <Button
            variant="ghost"
            size="small"
            onClick={() => toggleColumnMinimized(column.id)}
            style={MINIMIZE_BUTTON_STYLE}
          >
            ◀
          </Button>
        </Tooltip>
      </Grid>
      <Typography className={styles.normalColumnCount}>
        {childrenCount}
        {showPlus ? '+' : ''} {childrenCount === 1 ? 'chamado' : 'chamados'}
      </Typography>
    </Grid>
  )
}
